function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["resume", "tools"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { DefaultChatTransport, lastAssistantMessageIsCompleteWithToolCalls } from 'ai';
import { Chat } from "../../lib/chat/index.js";
import { checkRendering, createDocumentationMessageGenerator, createSendEventForHits, getAppIdAndApiKey, noop, warning } from "../../lib/utils/index.js";
var withUsage = createDocumentationMessageGenerator({
  name: 'chat',
  connector: true
});
export default (function connectChat(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  checkRendering(renderFn, withUsage());
  return function (widgetParams) {
    process.env.NODE_ENV === 'development' ? warning(false, 'Chat is not yet stable and will change in the future.') : void 0;
    var _ref = widgetParams || {},
      _ref$resume = _ref.resume,
      resume = _ref$resume === void 0 ? false : _ref$resume,
      _ref$tools = _ref.tools,
      tools = _ref$tools === void 0 ? {} : _ref$tools,
      options = _objectWithoutProperties(_ref, _excluded);
    var _chatInstance;
    var input = '';
    var open = false;
    var isClearing = false;
    var sendEvent;
    var setInput;
    var setOpen;
    var setIsClearing;
    var setMessages = function setMessages(messagesParam) {
      if (typeof messagesParam === 'function') {
        messagesParam = messagesParam(_chatInstance.messages);
      }
      _chatInstance.messages = messagesParam;
    };
    var clearMessages = function clearMessages() {
      if (!_chatInstance.messages || _chatInstance.messages.length === 0) {
        return;
      }
      setIsClearing(true);
    };
    var onClearTransitionEnd = function onClearTransitionEnd() {
      setMessages([]);
      _chatInstance.clearError();
      setIsClearing(false);
    };
    var makeChatInstance = function makeChatInstance(instantSearchInstance) {
      var transport;
      var _getAppIdAndApiKey = getAppIdAndApiKey(instantSearchInstance.client),
        _getAppIdAndApiKey2 = _slicedToArray(_getAppIdAndApiKey, 2),
        appId = _getAppIdAndApiKey2[0],
        apiKey = _getAppIdAndApiKey2[1];
      if ('transport' in options && options.transport) {
        transport = new DefaultChatTransport(options.transport);
      }
      if ('agentId' in options && options.agentId) {
        var agentId = options.agentId;
        if (!appId || !apiKey) {
          throw new Error(withUsage('Could not extract Algolia credentials from the search client.'));
        }
        transport = new DefaultChatTransport({
          api: "https://".concat(appId, ".algolia.net/agent-studio/1/agents/").concat(agentId, "/completions?compatibilityMode=ai-sdk-5"),
          headers: {
            'x-algolia-application-id': appId,
            'x-algolia-api-Key': apiKey
          }
        });
      }
      if (!transport) {
        throw new Error(withUsage('You need to provide either an `agentId` or a `transport`.'));
      }
      if ('chat' in options) {
        return options.chat;
      }
      return new Chat(_objectSpread(_objectSpread({}, options), {}, {
        transport: transport,
        sendAutomaticallyWhen: lastAssistantMessageIsCompleteWithToolCalls,
        onToolCall: function onToolCall(_ref2) {
          var toolCall = _ref2.toolCall;
          var tool = tools[toolCall.toolName];
          if (!tool) {
            if (process.env.NODE_ENV === 'development') {
              throw new Error("No tool implementation found for \"".concat(toolCall.toolName, "\". Please provide a tool implementation in the `tools` prop."));
            }
            return _chatInstance.addToolResult({
              output: "No tool implemented for \"".concat(toolCall.toolName, "\"."),
              tool: toolCall.toolName,
              toolCallId: toolCall.toolCallId
            });
          }
          if (tool.onToolCall) {
            var addToolResult = function addToolResult(_ref3) {
              var output = _ref3.output;
              return _chatInstance.addToolResult({
                output: output,
                tool: toolCall.toolName,
                toolCallId: toolCall.toolCallId
              });
            };
            return tool.onToolCall(_objectSpread(_objectSpread({}, toolCall), {}, {
              addToolResult: addToolResult
            }));
          }
          return Promise.resolve();
        }
      }));
    };
    return {
      $$type: 'ais.chat',
      init: function init(initOptions) {
        var _this = this;
        var instantSearchInstance = initOptions.instantSearchInstance;
        _chatInstance = makeChatInstance(instantSearchInstance);
        var render = function render() {
          renderFn(_objectSpread(_objectSpread({}, _this.getWidgetRenderState(initOptions)), {}, {
            instantSearchInstance: initOptions.instantSearchInstance
          }), false);
        };
        setOpen = function setOpen(o) {
          open = o;
          render();
        };
        setInput = function setInput(i) {
          input = i;
          render();
        };
        setIsClearing = function setIsClearing(value) {
          isClearing = value;
          render();
        };
        _chatInstance['~registerErrorCallback'](render);
        _chatInstance['~registerMessagesCallback'](render);
        _chatInstance['~registerStatusCallback'](render);
        if (resume) {
          _chatInstance.resumeStream();
        }
        renderFn(_objectSpread(_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(_objectSpread(_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState) {
        return renderState;
      },
      getWidgetRenderState: function getWidgetRenderState(renderState) {
        var instantSearchInstance = renderState.instantSearchInstance,
          parent = renderState.parent;
        if (!_chatInstance) {
          this.init(_objectSpread(_objectSpread({}, renderState), {}, {
            uiState: {},
            results: undefined
          }));
        }
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance: renderState.instantSearchInstance,
            helper: renderState.helper,
            widgetType: this.$$type
          });
        }
        var toolsWithAddToolResult = {};
        Object.entries(tools).forEach(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            tool = _ref5[1];
          var toolWithAddToolResult = _objectSpread(_objectSpread({}, tool), {}, {
            addToolResult: _chatInstance.addToolResult
          });
          toolsWithAddToolResult[key] = toolWithAddToolResult;
        });
        return {
          indexUiState: instantSearchInstance.getUiState()[parent.getIndexId()],
          input: input,
          open: open,
          sendEvent: sendEvent,
          setIndexUiState: parent.setIndexUiState.bind(parent),
          setInput: setInput,
          setOpen: setOpen,
          setMessages: setMessages,
          isClearing: isClearing,
          clearMessages: clearMessages,
          onClearTransitionEnd: onClearTransitionEnd,
          tools: toolsWithAddToolResult,
          widgetParams: widgetParams,
          // Chat instance render state
          addToolResult: _chatInstance.addToolResult,
          clearError: _chatInstance.clearError,
          error: _chatInstance.error,
          id: _chatInstance.id,
          messages: _chatInstance.messages,
          regenerate: _chatInstance.regenerate,
          resumeStream: _chatInstance.resumeStream,
          sendMessage: _chatInstance.sendMessage,
          status: _chatInstance.status,
          stop: _chatInstance.stop
        };
      },
      dispose: function dispose() {
        unmountFn();
      },
      shouldRender: function shouldRender() {
        return true;
      },
      get chatInstance() {
        return _chatInstance;
      }
    };
  };
});